<template>
    <div class="white-box white-box-no-tab pt-0 md:pt-5">
        <Title
            class="hidden md:block"
            :text="$route.meta.pageTitle"
            style-code-page
        />
        <TermsFrame
            need-layer
            need-btn
            :is-loading="isLoading"
            :btn-text="'本人已充分閱讀且暸解'"
            :content="listText"
            @clickBtn="goNext"
        />
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getBenefitRiskInfo, postAgreeBenefitRisk } from '@/apis/system';
import routeName from '@/router/constant.js';
import Title from '@/components/text/Title.vue';
import TermsFrame from '@/components/template/TermsFrame.vue';

export default {
    components: {
        Title,
        TermsFrame,
    },
    setup() {
        const router = useRouter();
        const listText = ref('');
        const isLoading = ref(false);

        /** 取得條款內容 */
        getBenefitRiskInfo().then((res) => {
            listText.value = res.data.agreeTerms.content;
        });

        const goNext = () => {
            isLoading.value = true;
            postAgreeBenefitRisk().then(() => {
                router.push({
                    name: routeName.CONFIRM_DATA
                });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            listText,
            isLoading,
            goNext
        };
    },
};
</script>
